module.exports = __webpack_public_path__ + "static/media/51_tn.cf457442.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/51_tn.jpg
// module id = 359
// module chunks = 0